const options = {
  5: "bg-orange-900/5",
  10: "bg-orange-900/10",
  25: "bg-orange-900/25",
  50: "bg-orange-900/50",
  75: "bg-orange-900/75",
  90: "bg-orange-900/90",
  100: "bg-orange-900",
};

const from = {
  5: "from-orange-900/5",
  10: "from-orange-900/10",
  25: "from-orange-900/25",
  50: "from-orange-900/50",
  75: "from-orange-900/75",
  90: "from-orange-900/90",
  100: "from-orange-900",
};

export default function getBackgroundOrange900(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
